/**
 * Created by sy on 2018/9/18.
 */
import { INDEX } from "./mutations-type";

export default {
  [INDEX.BANNERLIST](state, res) {
    // console.log('进入mutation')
    // state.getBannerList = { ...state.getBannerList,list: res.data.result.list}
    state.getBannerList = res.data.result.list;
    // console.log('进入mutation修改state成功')
  },
  //搜索关键词
  changeWord(state, payload) {
    state.searchWord = payload;
  },
  //搜索导航pos
  changeNav(state, payload) {
    state.searchNav = payload;
  },
  // [SEARCH.SEARCHWORD] (state, payload) {
  //   console.log('mutation==============' + payload)
  //   state.searchWord = payload
  // }
};
